<template>
  <div v-if="name != ''" class="resultTotalCell">
    <div class="resultTotalCell__mainComponent">
      <div class="resultTotalCell__total">&nbsp;</div>
      <div
        class="resultTotalCell__totalImg"
        :style="{ 'background-image': 'url(/img/normalIcon.png)' }"
      >
        <img
          class="resultTotalCell__eventImg"
          :src="getIconUrl(eventIconUrl, 128)"
        />
      </div>
      <div class="resultTotalCell__mainInformation">
        <p class="resultTotalCell__mainInformation__name">{{ name }}</p>
        <div v-if="showScore" class="resultTotalCell__mainInformation__value">
          <img v-bind:src="icon" alt="" />
          <p>{{ value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUrl from '@/utils/ImgUrl'
export default {
  name: 'ResultTotalCell',
  props: {
    eventIconUrl: String,
    showScore: Boolean,
    name: String,
    value: String,
    icon: String,
  },
  methods: {
    getIconUrl: function (baseUrl, size) {
      return ImgUrl.getIconUrlWithSize(baseUrl, size)
    },
  },
}
</script>

<style scoped>
.resultTotalCell {
  border-bottom: 1px solid #eeeeee;
}
.resultTotalCell__mainComponent {
  height: 73px;
  max-width: 500px;
  margin: 0 auto;
}
.resultTotalCell__total {
  display: inline-block;
  line-height: 73px;
  width: 41px;
  text-align: center;
  color: #262626;
  font-weight: bold;
}
.resultTotalCell__totalImg {
  display: inline-block;
  padding: 10px 8px 6px;
  background-size: contain;
}
.resultTotalCell__eventImg {
  display: inline-block;
  height: 44px;
  width: 44px;
  vertical-align: middle;
  border-radius: 50%;
}
.resultTotalCell__mainInformation {
  margin-right: 22px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 12px;
}
.resultTotalCell__mainInformation__name {
  margin: 0;
  font-weight: 600;
  max-width: 180px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.resultTotalCell__mainInformation__value {
  margin: 0;
}
.resultTotalCell__mainInformation__value img {
  display: inline-block;
  width: 14px;
  height: 15px;
  vertical-align: middle;
  margin-bottom: 2px;
}
.resultTotalCell__mainInformation__value p {
  display: inline;
  color: #188dff;
  font-size: 14px;
  vertical-align: middle;
  margin-left: 6px;
}
</style>
